var React = require('react');

function FacebookRound (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0H0v24h10.842v-8.735H8.727v-2.396h2.115V11.55c0-1.598.427-2.831 1.281-3.7.855-.87 2.05-1.306 3.589-1.306.546 0 1.127.08 1.742.24l-.076 2.53a5.912 5.912 0 0 0-1.192-.107c-1.487 0-2.23.794-2.23 2.383v1.278h2.82v2.396h-2.82V24H24V0Z","fill":"currentColor"}))]);
}

FacebookRound.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookRound;

FacebookRound.default = FacebookRound;
